import React, { memo, useRef } from "react";
import "./section5.css";
import { FiLayers, FiUsers, FiSmile } from "react-icons/fi";
import { InstagramEmbed } from "react-social-media-embed";
import Slider from "react-slick";
import { BsArrowRightShort, BsArrowLeftShort } from "react-icons/bs";

const facts = [
  {
    key: 1,
    count: "100+",
    task: "Projects Done",
    icon: <FiLayers size="1.6em" />,
  },
  {
    key: 2,
    count: "200+",
    task: "Satisfied Clients",
    icon: <FiUsers size="1.6em" />,
  },
  {
    key: 3,
    count: "1K+",
    task: "Happy Smiles",
    icon: <FiSmile size="1.6em" />,
  },
];

const instaFeeds = [
  {
    key: "12",
    url: "https://www.instagram.com/p/COwzSWPlbOF/?utm_source=ig_web_copy_link",
  },
  {
    key: "31",
    url: "https://www.instagram.com/p/B_SVAARFTPx/?utm_source=ig_web_copy_link",
  },
  {
    key: "123",
    url: "https://www.instagram.com/p/CAfMKgtF1hL/?utm_source=ig_web_copy_link",
  },
  {
    key: "125",
    url: "https://www.instagram.com/p/CIUzWQalql3/?utm_source=ig_web_copy_link",
  },
  {
    key: "126",
    url: "https://www.instagram.com/p/B566YA0lnK9/?utm_source=ig_web_copy_link",
  },
  {
    key: "127",
    url: "https://www.instagram.com/p/B51kkb0Fxrr/?utm_source=ig_web_copy_link",
  },
  {
    key: "2",
    url: "https://www.instagram.com/p/B15YJ65FRBP/?utm_source=ig_web_copy_link",
  },
  {
    key: "3",
    url: "https://www.instagram.com/p/B3zZAycF1Ov/?utm_source=ig_web_copy_link",
  },
  {
    key: "6",
    url: "https://www.instagram.com/p/BrR2H44Fc6T/?utm_source=ig_web_copy_link",
  },
  {
    key: "7",
    url: "https://www.instagram.com/p/Bmi8Ub-HOVU/?utm_source=ig_web_copy_link",
  },
  {
    key: "8",
    url: "https://www.instagram.com/p/BqwXOuulUk_/?utm_source=ig_web_copy_link",
  },
  {
    key: "90",
    url: "https://www.instagram.com/p/B6K7b1LFQJa/?utm_source=ig_web_copy_link",
  },
];

const development = [
  {
    id: "webook",
    name: "webook.com",
    url: "",
    src: "/images/webook.png",
  },
  {
    id: "sagp",
    name: "Saudi Arabian Grand Prix",
    url: "",
    src: "/images/sagp.png",
  },
  {
    id: "hy",
    name: "Halayalla",
    url: "",
    src: "/images/hy.jpg",
  },
  {
    id: "ittihad",
    name: "Al-Ittihad Tickets",
    url: "",
    src: "/images/ittihad.png",
  },
  {
    id: "sfa",
    name: "Saudi Sports for all",
    url: "",
    src: "/images/safa.png",
  },
  {
    id: "riyadh-season",
    name: "Riyadh Season",
    url: "",
    src: "/images/riyadhseason.png",
  },
  {
    id: "alawwal",
    name: "Alawwal Park",
    url: "",
    src: "/images/alawwal.png",
  },
  {
    id: "fcwc",
    name: "FIFA Club World Cup",
    url: "",
    src: "/images/fcwc.png",
  },
  {
    id: 2,
    name: "ViewBox",
    url: "https://play.google.com/store/apps/details?id=viewbox.screen&hl=en_IN",
    src: "/images/viewbox.png",
  },
  {
    id: 5,
    name: "Badan",
    url: "http://badan.com.sa/",
    src: "/images/badan.png",
  },
  {
    id: 7,
    name: "Five Star Chicken",
    url: "https://apps.apple.com/in/app/fivestar-chicken/id1577090660",
    src: "/images/fivestar.png",
  },

  {
    id: 10,
    name: "ES Petty Cash",
    url: "https://apps.apple.com/in/app/es-petty-cash/id1542061973",
    src: "/images/pettycash.png",
  },
  {
    id: 9,
    name: "Go Station",
    url: "https://apps.apple.com/in/app/go-station-facility-app/id1584491627",
    src: "/images/gostation.png",
  },
];

const SocialItem = memo(({ i }) => {
  return (
    <div className="d-flex justify-content-center project-slick">
      <InstagramEmbed url={i.url} className="insta-c" />
    </div>
  );
});

const settings = {
  dots: false,
  slidesToShow: 4,
  slidesToScroll: 1,
  centerMode: true,
  speed: 1000,
  arrows: false,
  pauseOnHover: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const _renderSocialItem = (i) => <SocialItem key={i.key + i?.url} i={i} />;

const Section5 = React.forwardRef(() => {
  const slider = useRef(null);

  return (
    <section className="section5 py-5 pt-0">
      <div className="container">
        <div className="row ">
          <div className="col d-flex align-items-center justify-content-between">
            <div className="section-header">
              <h1 className="font-weight-bold mb-0 display-md-4 display-3">
                <span className="text-primary">{"<"}</span>Code Concoctions
                <span className="text-primary">{"/>"}</span>
              </h1>
            </div>
          </div>
        </div>
        <div className="row mt-5 pt-2">
          {development.map((d) => (
            <div key={d.id} className="col-lg-2 col-md-3 col-6 mb-5">
              <a
                href={d?.url}
                target="_blank"
                data-aos="zoom-in"
                rel="noopener noreferrer"
                className="development-container px-1 h-100 d-flex align-items-center"
              >
                <div className="app-icon-container">
                  <img
                    src={d.src}
                    style={{ borderRadius: 5 }}
                    className="app-icon"
                    alt={d?.name}
                  />
                </div>
                <p className="mt-2 pt-1 font-weight-normal text-center mb-0 text-body">
                  {d.name}
                </p>
              </a>
            </div>
          ))}
          <div className="col-md-2 col-6 mb-5">
            <div
              data-aos="zoom-in"
              className="development-container px-1 h-100 d-flex align-items-center"
            >
              <div
                className="app-icon-container"
                style={{ backgroundColor: "rgba(0,0,0,0.05)", borderRadius: 5 }}
              >
                <img
                  src={"/images/installing.png"}
                  style={{ borderRadius: 5, overflow: "hiddden" }}
                  className="app-icon"
                  alt={"installing"}
                />
              </div>
              <p className="mt-2 pt-1 font-weight-normal text-center mb-0 text-body">
                Installing...
              </p>
            </div>
          </div>
        </div>
        <div className="row mt-5 ">
          <div className="col d-flex align-items-center justify-content-between">
            <div className="section-header flex-grow-1">
              <h1 className="font-weight-bold mb-0 display-4">
                From Pixels to Giggles
              </h1>
              <div
                data-aos="fade-right"
                className="underline w-25 d-none d-md-block"
              ></div>
            </div>
            <BsArrowLeftShort
              onClick={() => slider.current.slickPrev()}
              className="mouse-point mr-md-3 mr-2"
              size={"2em"}
            />
            <BsArrowRightShort
              onClick={() => slider.current.slickNext()}
              className="ml-md-3 ml-2 mouse-point"
              size={"2em"}
            />
          </div>
        </div>
      </div>
      <div className="slider-wrapper mt-4 pt-4">
        <Slider
          ref={slider}
          {...settings}
          focusOnSelect={false}
          lazyLoad="progressive"
        >
          {instaFeeds.map(_renderSocialItem)}
        </Slider>
      </div>
      <div className="container">
        <div className="row mb-4 mt-5 pt-4 px-3 px-md-0">
          {facts.map((f) => (
            <div
              key={f.key}
              className="col-md col-12 facts-container py-3 mx-md-4 mt-md-0 mt-4"
            >
              <div data-aos="zoom-out" className="icon">
                {f.icon}
              </div>
              <h1 className="font-weight-bold display-4 text-primary">
                {f.count}
              </h1>
              <h5>{f.task}</h5>
            </div>
          ))}
        </div>
        {/* <div className="row mt-4 align-items-center pb-2">
          <div className="col-md-9 col-12">
            <p className="mb-0 text-md-left font-weight-light">
              I focus on interactive and informative video and poster design
              which engages your audience leave a lasting impact on them and try
              to amaze your customers with professional corporate video.
            </p>
          </div>
          <div className="col-md col-12 mt-md-0 mt-3">
            <button
              onClick={() =>
                window.open("https://www.instagram.com/mefx_studio/")
              }
              type="button"
              className="btn btn-outline-primary btn-block py-2 px-4"
            >
              <p className="mb-0 py-1">Follow on Instagram</p>
            </button>
          </div>
        </div> */}

        {/* <div className="row mt-4 align-items-center pb-md-5 pb-4">
          <div className="col">
            <p className="mb-0 text-md-left font-weight-light">
              I research and analyze different views in your industry to craft a
              specific design that is effective and has higher conversion rate.
              I develop the project using cutting edge technology and best
              practices. Before going live, I go through various checkpoints and
              other extensive quality assurance processes.
            </p>
          </div>
        </div> */}
      </div>
    </section>
  );
});

export default memo(Section5);
